import * as React from "react";

import { cn } from "../lib/cn";

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/** Loading placeholder. Decorative, so it is hidden from assistive tech. */
export function Skeleton({ className, ...props }: SkeletonProps): React.JSX.Element {
  return (
    <div aria-hidden className={cn("bg-muted animate-pulse rounded-md", className)} {...props} />
  );
}
